import { ApiDataResponse } from '@app/types/dto';
import {
  CM004SearchProjectResponse,
  ConfirmedMessageListResponse,
  GetBimProjectIdPayload,
  GetBimProjectIdResponse,
  MasterCodeItemResponse,
  MasterCodePayload,
  ProfessionRoleItemResponse,
  SearchProjectPayload,
  UnreadMessageResponse,
  UpdateConfirmStatusPayload,
  UpdateReadStatusPayload,
  UpdateReadStatusResponse,
} from '@app/types/initScreen';
import { TopPanelInfoData } from '@app/types/project';
import { apiCall } from './api';
import {
  COMMON_ENDPOINTS,
  DATASET_ENDPOINTS,
  IFC_ENDPOINTS,
  MASTER_CODE_ENDPOINTS,
  PROJECT_ENDPOINTS,
  PROJECT_SELECTION_ENDPOINTS,
} from './endpointUrl';

export const commonApiService = {
  /**
   * Get top panel info
   * GET /api/v1/projects/{project_id}/top-panel-info
   */
  getTopPanelInfo: (projectId: number): Promise<ApiDataResponse<TopPanelInfoData>> => {
    return apiCall<ApiDataResponse<TopPanelInfoData>>(PROJECT_ENDPOINTS.TOP_PANEL_INFO(projectId), {
      method: 'GET',
    });
  },

  /**
   * Get Profession and Role APIs
   * GET /api/profession-role
   */
  getProfessionRole: (): Promise<ApiDataResponse<ProfessionRoleItemResponse>> => {
    return apiCall<ApiDataResponse<ProfessionRoleItemResponse>>(PROJECT_ENDPOINTS.PROFESSION_ROLE, {
      method: 'GET',
    });
  },

  /**
   * API-Common-Get-Master-Code
   * POST /api/master-code
   * { codeType: string }
   */
  getMasterCodeOptions: (payload: MasterCodePayload): Promise<ApiDataResponse<MasterCodeItemResponse>> => {
    return apiCall<ApiDataResponse<MasterCodeItemResponse>>(MASTER_CODE_ENDPOINTS.BY_CODE_TYPE, {
      method: 'POST',
      data: payload,
    });
  },

  /**
   * API-COM-002: API download IFC file.
   * GET /api/ifc/:IFC_FILE_ID/download
   * Ex: /api/ifc/123/download
   */
  downloadIfcFile: (ifcFileId: number): Promise<ApiDataResponse<{ content: string }>> => {
    return apiCall<ApiDataResponse<{ content: string }>>(IFC_ENDPOINTS.IFC_DOWNLOAD(ifcFileId), {
      method: 'GET',
    });
  },

  /**
   * API-COM-004: API to download the dataset.
   * GET /api/dataset/{datasetId}/download
   */
  downloadDataset: (datasetId: number): Promise<ApiDataResponse<{ content: string }>> => {
    return apiCall<ApiDataResponse<{ content: string }>>(DATASET_ENDPOINTS.DATASET_DOWNLOAD(datasetId), {
      method: 'GET',
    });
  },

  /**
   * API-CM004-01_SearchProject
   * POST /api/project/search
   */
  searchProject: (payload: SearchProjectPayload): Promise<ApiDataResponse<CM004SearchProjectResponse>> => {
    return apiCall<ApiDataResponse<CM004SearchProjectResponse>>(PROJECT_SELECTION_ENDPOINTS.SEARCH_PROJECT, {
      method: 'POST',
      data: payload,
    });
  },
  /**
   * API-NOTIFY-01_UnreadMessageList
   * GET /api/notifications/unread-message-list
   */
  unreadMessageList: (): Promise<ApiDataResponse<UnreadMessageResponse>> => {
    return apiCall<ApiDataResponse<UnreadMessageResponse>>(PROJECT_SELECTION_ENDPOINTS.UNREAD_MESSAGE_LIST, {
      method: 'GET',
    });
  },
  /**
   * API-NOTIFY-02_UpdateReadStatus
   * POST /api/notifications/update-read-status
   */
  updateReadStatus: (payload: UpdateReadStatusPayload): Promise<ApiDataResponse<UpdateReadStatusResponse>> => {
    return apiCall<ApiDataResponse<UpdateReadStatusResponse>>(PROJECT_SELECTION_ENDPOINTS.UPDATE_READ_STATUS, {
      method: 'POST',
      data: payload,
    });
  },
  /**
   * API-NOTIFY-03_ConfirmedMessageList
   * GET /api/notifications/confirmed-message-list
   */
  confirmedMessageList: (): Promise<ApiDataResponse<ConfirmedMessageListResponse>> => {
    return apiCall<ApiDataResponse<ConfirmedMessageListResponse>>(PROJECT_SELECTION_ENDPOINTS.CONFIRMED_MESSAGE_LIST, {
      method: 'GET',
    });
  },
  /**
   * API-NOTIFY-04_ReadAllMessages
   * POST /api/notifications/read-all
   */
  readAllMessages: (): Promise<ApiDataResponse<string>> => {
    return apiCall<ApiDataResponse<string>>(PROJECT_SELECTION_ENDPOINTS.READ_ALL_MESSAGES, {
      method: 'POST',
    });
  },
  /**
   * API-NOTIFY-06_UpdateConfirmStatus
   * POST /api/notifications/update-confirm-status
   */
  updateConfirmStatus: (payload: UpdateConfirmStatusPayload): Promise<ApiDataResponse<string>> => {
    return apiCall<ApiDataResponse<string>>(PROJECT_SELECTION_ENDPOINTS.UPDATE_CONFIRM_STATUS, {
      method: 'POST',
      data: payload,
    });
  },

  /**
   * GET /api/project/{designPortalProjectId}/bim-id
   */
  getBimProjectId: (payload: GetBimProjectIdPayload): Promise<ApiDataResponse<GetBimProjectIdResponse>> => {
    return apiCall<ApiDataResponse<GetBimProjectIdResponse>>(COMMON_ENDPOINTS.GET_BIM_PROJECT_ID(payload.designPortalProjectId), {
      method: 'GET',
    });
  },
};
